export enum UserRoleIds{
    ADMIN = 1,
    REGULAR_USER = 2,
    SOCIAL_SERVICES = 3,
    MANAGER = 4,
    SPECIAL_NEEDS = 5,
}
